import { createFileRoute } from "@tanstack/react-router";
import { all } from "better-all";
import { assert } from "utils";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachLibraryExerciseDetailsPage } from "src/pages/CoachLibraryExerciseDetailsPage";
import { createPersonalLibraryExercisesRepository } from "src/repositories/exercises/createPersonalLibraryExercisesRepository";
import { exerciseCategoriesQueryOptions } from "src/state/exerciseCategories";
import { exerciseMovementPatternsQueryOptions } from "src/state/exerciseMovementPatterns";
import { exerciseMuscleGroupsQueryOptions } from "src/state/exerciseMuscleGroups";

export const Route = createFileRoute(
  "/_auth/_coach/library/exercises/$exerciseId",
)({
  component: CoachLibraryExerciseDetailsPage,
  async loader({ context, params }) {
    return await loaderHandler(async () => {
      assert(params.exerciseId, "params.exerciseId is required");

      const exercisesRepository = createPersonalLibraryExercisesRepository();
      const props = await all({
        async exerciseData() {
          return context.queryClient.query({
            ...exercisesRepository.detailOptions(params.exerciseId),
            staleTime: "static",
          });
        },
        async categories() {
          return context.queryClient.query({
            ...exerciseCategoriesQueryOptions(),
            staleTime: "static",
          });
        },
        async muscleGroups() {
          return context.queryClient.query({
            ...exerciseMuscleGroupsQueryOptions(),
            staleTime: "static",
          });
        },
        async movementPatterns() {
          return context.queryClient.query({
            ...exerciseMovementPatternsQueryOptions(),
            staleTime: "static",
          });
        },
      });

      return {
        data: {
          eGet: props.exerciseData,
        },
        breadcrumb: {
          label: props.exerciseData.exercise.name,
          href: `/library/exercises/${params.exerciseId}`,
          id: props.exerciseData.exercise.id,
        },
      };
    });
  },
  head({ loaderData }) {
    if (!loaderData) {
      return {
        meta: [],
      };
    }

    return {
      meta: [{ title: `${loaderData?.data.eGet.exercise.name} | sztama` }],
    };
  },
});
